module.exports = __webpack_public_path__ + "static/img/qr.359322cc.jpeg";